<template>
  <!--  노션 링크 : https://www.notion.so/InfoguidancePage-7733b7e89dd44cee9e0c1193a6f3e794 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="infoguidance_breadcrumb" />
    </div>
    <div class="header">
      <!--      <h1 class="overlay">GUIDE PROGRAM</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('info_title') }}</strong>
        </h2>
      </div>
    </div>

    <div class="container">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 1 || isLang === 0}">
          <b-tabs fill @activate-tab="changeTab" v-model="tabIndex">
            <b-tab :title="$t('tab1_title')" active>
              <b-container class="mb-5">
                <h4 style="margin-top: 50px; margin-bottom: 30px">
                  <strong>{{ $t('tab1_body_title1') }}</strong>
                </h4>
                <p style="margin: 0">
                  {{ $t('tab1_body_desc1') }}
                </p>
                <p>{{ $t('tab1_body_desc2') }}</p>

                <h4 style="margin-top: 100px; margin-bottom: 30px">
                  <strong>{{ $t('tab1_body_title2') }}</strong>
                </h4>
                <p style="margin: 0">{{ $t('tab1_body_desc3') }}</p>
                <p style="margin: 0">{{ $t('tab1_body_desc4') }}</p>
                <p style="margin-top: 4px; text-indent: 1em; color: gray; font-size: 0.9rem">
                  {{ $t('tab1_body_desc4_1') }}
                </p>
                <h6 style="margin-top: 100px">
                  <strong>{{ $t('tab1_body_title3') }}</strong>
                </h6>
                <p style="margin: 0">{{ $t('tab1_body_desc5') }}</p>
                <p style="margin-bottom: 130px">{{ $t('tab1_body_desc6') }}</p>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab2_title')">
              <b-container class="mb-5">
                <b-row>
                  <b-col md="6">
                    <ul class="etiq_rev list-unstyled" style="line-height: 2">
                      <h4 style="margin-top: 50px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title1') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc1_1') }}</li>
                      <li>{{ $t('tab2_body_desc1_2') }}</li>
                      <li>{{ $t('tab2_body_desc1_3') }}</li>
                      <li>{{ $t('tab2_body_desc1_4') }}</li>
                      <p>{{ $t('tab2_body_desc1_5') }}</p>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title2') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc2_1') }}</li>
                      <li>{{ $t('tab2_body_desc2_2') }}</li>
                      <li>{{ $t('tab2_body_desc2_3') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title3') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc3_1') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title4') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc4_1') }}</li>
                      <div style="margin-top: 10px; text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_1') }}
                      </div>
                      <div style="text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_2') }}
                      </div>
                      <div style="text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_3') }}
                      </div>
                      <div style="text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_4') }}
                      </div>
                      <div style="text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_5') }}
                      </div>
                      <div style="margin-bottom: 20px; text-indent: 1em; color: gray; font-size: 0.9rem">
                        {{ $t('tab2_body_desc4_1_6') }}
                      </div>
                      <li>{{ $t('tab2_body_desc4_2') }}</li>
                      <li>{{ $t('tab2_body_desc4_3') }}</li>
                      <li>{{ $t('tab2_body_desc4_4') }}</li>
                      <li>{{ $t('tab2_body_desc4_5') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title5') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc5_1') }}</li>
                      <li>{{ $t('tab2_body_desc5_2') }}</li>
                      <li>{{ $t('tab2_body_desc5_3') }}</li>
                      <li>{{ $t('tab2_body_desc5_4') }}</li>
                      <li>{{ $t('tab2_body_desc5_5') }}</li>
                      <li>{{ $t('tab2_body_desc5_6') }}</li>
                    </ul>
                  </b-col>
                  <b-col>
                    <ul class="etiq_rev list-unstyled" style="line-height: 2">
                      <h4 style="margin-top: 50px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title6') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc6_1') }}</li>
                      <li>{{ $t('tab2_body_desc6_2') }}</li>
                      <li>{{ $t('tab2_body_desc6_3') }}</li>
                      <li>{{ $t('tab2_body_desc6_4') }}</li>
                      <li>{{ $t('tab2_body_desc6_5') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title7') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc7_1') }}</li>
                      <li>{{ $t('tab2_body_desc7_2') }}</li>
                      <li>{{ $t('tab2_body_desc7_3') }}</li>
                      <li>{{ $t('tab2_body_desc7_4') }}</li>
                      <li>{{ $t('tab2_body_desc7_5') }}</li>
                      <li>{{ $t('tab2_body_desc7_6') }}</li>
                      <li>{{ $t('tab2_body_desc7_7') }}</li>
                      <li>{{ $t('tab2_body_desc7_8') }}</li>
                      <li>{{ $t('tab2_body_desc7_9') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title8') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc8_1') }}</li>
                      <li>{{ $t('tab2_body_desc8_2') }}</li>
                      <li>{{ $t('tab2_body_desc8_3') }}</li>
                      <h4 style="margin-top: 100px; margin-bottom: 30px">
                        <strong>{{ $t('tab2_body_title9') }}</strong>
                      </h4>
                      <li>{{ $t('tab2_body_desc9_1') }}</li>
                      <li>{{ $t('tab2_body_desc9_2') }}</li>
                      <li>{{ $t('tab2_body_desc9_3') }}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab3_title')">
              <b-container class="mb-5">
                <ul class="etiq_rev list-unstyled">
                  <h4 style="margin-top: 50px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title1') }}</strong>
                  </h4>
                  <li>{{ $t('tab3_body_desc1_1') }}</li>
                  <li>{{ $t('tab3_body_desc1_2') }}</li>
                  <div style="text-indent: 1em; color: gray">
                    {{ $t('tab3_body_desc1_3') }}
                  </div>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc1_4') }}</div>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title2') }}</strong>
                  </h4>
                  <li>{{ $t('tab3_body_desc2_1') }}</li>
                  <p>{{ $t('tab3_body_desc2_2') }}</p>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title3') }}</strong>
                  </h4>
                  <li>{{ $t('tab3_body_desc3_1') }}</li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title4') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc4_1') }}
                  </li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title5') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc5_1') }}
                  </li>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc5_2') }}</div>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc5_2_1') }}</div>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc5_2_2') }}</div>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc5_2_3') }}</div>
                  <div style="text-indent: 1em; color: gray">{{ $t('tab3_body_desc5_2_4') }}</div>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title6') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc6_1') }}
                  </li>
                  <div style="text-indent: 1em; color: gray">
                    {{ $t('tab3_body_desc6_2') }}
                  </div>
                  <div style="text-indent: 1em; color: gray">
                    {{ $t('tab3_body_desc6_3') }}
                  </div>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title7') }}</strong>
                  </h4>
                  <li>{{ $t('tab3_body_desc7_1') }}</li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title8') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc8_1') }}
                  </li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title9') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc9_1') }}
                  </li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title10') }}</strong>
                  </h4>
                  <li>{{ $t('tab3_body_desc10_1') }}</li>
                  <li>{{ $t('tab3_body_desc10_2') }}</li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title11') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc11_1') }}
                  </li>
                  <li>{{ $t('tab3_body_desc11_2') }}</li>
                  <li>{{ $t('tab3_body_desc11_3') }}</li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title12') }}</strong>
                  </h4>
                  <li>
                    {{ $t('tab3_body_desc12_1') }}
                  </li>
                  <h4 style="margin-top: 100px; margin-bottom: 30px">
                    <strong>{{ $t('tab3_body_title13') }}</strong>
                  </h4>
                </ul>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab4_title')" v-if="isLang === 0 && !isMobile()">
              <b-container class="mb-5">
                <h4 id="movFrame" style="margin-top: 50px; margin-bottom: 30px">
                  <strong>{{ $t('tab4_body_title1') }}</strong>
                </h4>
                <div class="golf-mainvideo col-sm-12 embed-responsive embed-responsive-16by9">
                  <iframe
                    ref="player"
                    id="movPlayer"
                    class="embed-responsive-item"
                    :src="this.mov_list[this.currentMovNum].url"
                    allowfullscreen
                  ></iframe>
                </div>
                <div>
                  <div class="mov-title" v-if="isLang === 0">
                    {{ this.mov_list[this.currentMovNum].title_kr }}
                  </div>
                  <div class="mov-title" v-else-if="isLang === 1">
                    {{ this.mov_list[this.currentMovNum].title_en }}
                  </div>
                  <div class="mov-title" v-else>
                    {{ this.mov_list[this.currentMovNum].title_ja }}
                  </div>
                </div>
                <div class="rowSpace"></div>
                <div class="row d-flex">
                  <div v-for="(item, index) in mov_list" :key="index" class="col-lg-4 col-12 mb-4">
                    <template>
                      <div class="card" @click="selectMov(index)" style="cursor: pointer">
                        <img
                          class="card-img-top thumb-img"
                          :src="item.image"
                          alt="Card image cap"
                          style="padding: 10px"
                        />
                        <div class="card-body" style="padding: 10px 20px">
                          <div class="card-title" style="letter-spacing: -0.05rem">
                            <div class="thumb-title" v-if="isLang === 0">{{ item.title_kr }}</div>
                            <div class="thumb-title" v-else-if="isLang === 1">{{ item.title_en }}</div>
                            <div class="thumb-title" v-else>{{ item.title_ja }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab4_title_m')" v-if="isLang === 0 && isMobile()">
              <b-container class="mb-5">
                <h4 id="movFrame" style="margin-top: 50px; margin-bottom: 30px">
                  <strong>{{ $t('tab4_body_title1') }}</strong>
                </h4>
                <div class="golf-mainvideo col-sm-12 embed-responsive embed-responsive-16by9">
                  <iframe
                    ref="player"
                    id="movPlayer"
                    class="embed-responsive-item"
                    :src="this.mov_list[this.currentMovNum].url"
                    allowfullscreen
                  ></iframe>
                </div>
                <div>
                  <div class="mov-title" v-if="isLang === 0">
                    {{ this.mov_list[this.currentMovNum].title_kr_m }}
                  </div>
                  <div class="mov-title" v-else-if="isLang === 1">
                    {{ this.mov_list[this.currentMovNum].title_en }}
                  </div>
                  <div class="mov-title" v-else>
                    {{ this.mov_list[this.currentMovNum].title_ja }}
                  </div>
                </div>
                <div class="rowSpace"></div>
                <div class="row d-flex">
                  <div v-for="(item, index) in mov_list" :key="index" class="col-lg-4 col-12 mb-4">
                    <template>
                      <div class="card" @click="selectMov(index)" style="cursor: pointer">
                        <img
                          class="card-img-top thumb-img"
                          :src="item.image"
                          alt="Card image cap"
                          style="padding: 10px"
                        />
                        <div class="card-body" style="padding: 10px 20px">
                          <div class="card-title" style="letter-spacing: -0.02rem">
                            <div class="thumb-title" v-if="isLang === 0">{{ item.title_kr_m }}</div>
                            <div class="thumb-title" v-else-if="isLang === 1">{{ item.title_en }}</div>
                            <div class="thumb-title" v-else>{{ item.title_ja }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-container>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import vueVimeoPlayer from 'vue-vimeo-player';
import Player from '@vimeo/player';

export default {
  name: 'InfoguidancePage',
  data() {
    return {
      infoguidance_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'OPERATION GUIDE',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
      currentMovNum: 0,
      options: {
        muted: false,
        autoplay: true,
        responsive: true,
        resize: true,
      },
      mov_list: [
        {
          idx: 1,
          title_kr: '변기수의 골프장 블랙박스 ‘골프복장’편',
          title_kr_m: '핀크스GC ‘골프복장’편',
          title_en: '변기수의 골프장 블랙박스 ‘골프복장’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘골프복장’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_01.jpg'),
          url: 'https://player.vimeo.com/video/766349230?h=19c9c17a64',
        },
        {
          idx: 2,
          title_kr: '변기수의 골프장 블랙박스 ‘경기지연’편',
          title_kr_m: '핀크스GC ‘경기지연’편',
          title_en: '변기수의 골프장 블랙박스 ‘경기지연’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘경기지연’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_02.jpg'),
          url: 'https://player.vimeo.com/video/766349325?h=5bfd0b7d17',
        },
        {
          idx: 3,
          title_kr: '변기수의 골프장 블랙박스 ‘볼타구’편',
          title_kr_m: '핀크스GC ‘볼타구’편',
          title_en: '변기수의 골프장 블랙박스 ‘볼타구’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘볼타구’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_03.jpg'),
          url: 'https://player.vimeo.com/video/766349380?h=8effa167a1',
        },
        {
          idx: 4,
          title_kr: '변기수의 골프장 블랙박스 ‘골프카트’편',
          title_kr_m: '핀크스GC ‘골프카트’편',
          title_en: '변기수의 골프장 블랙박스 ‘골프카트’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘골프카트’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_04.jpg'),
          url: 'https://player.vimeo.com/video/766349283?h=5b315f6fe3',
        },
        {
          idx: 5,
          title_kr: '변기수의 골프장 블랙박스 ‘벙커정리’편',
          title_kr_m: '핀크스GC ‘벙커정리’편',
          title_en: '변기수의 골프장 블랙박스 ‘벙커정리’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘벙커정리’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_05.jpg'),
          url: 'https://player.vimeo.com/video/766349122?h=676b49fd72',
        },
        {
          idx: 6,
          title_kr: '변기수의 골프장 블랙박스 ‘워터해저드1’편',
          title_kr_m: '핀크스GC ‘워터해저드1’편',
          title_en: '변기수의 골프장 블랙박스 ‘워터해저드1’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘워터해저드1’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_06.jpg'),
          url: 'https://player.vimeo.com/video/766349478?h=6ce5bc920b',
        },
        {
          idx: 7,
          title_kr: '변기수의 골프장 블랙박스 ‘워터해저드2’편',
          title_kr_m: '핀크스GC ‘워터해저드2’편',
          title_en: '변기수의 골프장 블랙박스 ‘워터해저드2’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘워터해저드2’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_07.jpg'),
          url: 'https://player.vimeo.com/video/766349537?h=e093b9ccf3',
        },
        {
          idx: 8,
          title_kr: '변기수의 골프장 블랙박스 ‘워터해저드3’편',
          title_kr_m: '핀크스GC ‘워터해저드3’편',
          title_en: '변기수의 골프장 블랙박스 ‘워터해저드3’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘워터해저드3’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_08.jpg'),
          url: 'https://player.vimeo.com/video/766349576?h=1ffc11e970',
        },
        {
          idx: 9,
          title_kr: '변기수의 골프장 블랙박스 ‘페어웨이 디봇’편',
          title_kr_m: '핀크스GC ‘페어웨이 디봇’편',
          title_en: '변기수의 골프장 블랙박스 ‘페어웨이 디봇’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘페어웨이 디봇’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_09.jpg'),
          url: 'https://player.vimeo.com/video/766349433?h=b079cd03aa',
        },
        {
          idx: 10,
          title_kr: '변기수의 골프장 블랙박스 ‘그린 스크래치 금지’편',
          title_kr_m: '핀크스GC ‘그린 스크래치 금지’편',
          title_en: '변기수의 골프장 블랙박스 ‘그린 스크래치 금지’편_en',
          title_ja: '변기수의 골프장 블랙박스 ‘그린 스크래치 금지’편_ja',
          image: require('@/assets/images/Golf/Infoguidance/infoguidance_mov_10.jpg'),
          url: 'https://player.vimeo.com/video/766349172?h=8b99ab1195',
        },
      ],
      tabIndex: 0,
      playing: true,
    };
  },
  mounted() {
    if (this.$route.query.tab) {
      this.$nextTick(() => {
        this.changeTab(parseInt(this.$route.query.tab));
      });
    }
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.infoguidance_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'OPERATION GUIDE',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
    selectMov(num) {
      this.currentMovNum = num;
      this.moveToMovFrame();
      console.log(this.currentMovNum);
    },
    moveToMovFrame() {
      const element = document.getElementById('movFrame');
      element.scrollIntoView();
    },

    changeTab(newTabIndex) {
      this.tabIndex = newTabIndex;
      if (this.tabIndex !== 3) {
        const iframeTag = document.querySelector('iframe');
        const player = new Player(iframeTag);
        player.pause();
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
ul.etiq_rev li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}
.jpword {
  word-break: break-all;
}
.anotherword {
  li {
    text-indent: -0.5em;
    margin-left: 0.5em;
    word-break: keep-all;
  }
  p {
    word-break: keep-all;
  }
}
::v-deep a {
  color: #000 !important;
}
::v-deep .nav-tabs .nav-link.active {
  //margin: 0 3px;
  //margin-bottom: -1px;
  //padding-top: 16px;
  //padding-bottom: 12px;
  //background-color: #f9f9f9;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #000;
  font-weight: 600;
  //font-size: 17px;
  //line-height: 1.2;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
.rowSpace {
  height: 1rem;
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/operationguide_headerimage.png');
  }
  .mov-title {
    font-size: 1rem;
    font-weight: bold;
    padding: 1rem 1rem;
    border: 1px solid #d7d7d7;
  }
  .thumb-title {
    font-size: 0.9rem;
    font-weight: bold;
  }
  .thumb-img {
    height: 15rem;
    width: 100%;
    object-fit: cover;
  }
  .web {
  }

  .mobile {
    display: none;
  }
}
@media (max-width: 992px) {
  h4 {
    font-size: 1.2rem !important;
  }

  li,
  div {
    font-size: 0.9rem !important;
  }

  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  ::v-deep .nav-tabs {
    font-size: 0.8rem;
  }

  ::v-deep .nav-link {
    font-size: 0.8rem;
    padding: 1rem 0;
  }
  .mov-title {
    font-size: 0.9rem;
    font-weight: bold;
    padding: 1rem 1rem;
    border: 1px solid #d7d7d7;
  }
  .thumb-title {
    font-size: 0.8rem;
    font-weight: bold;
  }
  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "이용안내",
    "info_title": "이용 안내",
    "tab1_title": "복장규정",
    "tab2_title": "골프 에티켓",
    "tab3_title": "LOCAL RULES",
    "tab4_title": "변기수의 골프장 블랙박스",
    "tab4_title_m": "핀크스GC 블랙박스",

    "tab1_body_title1": "내장 시",
    "tab1_body_desc1": "클럽의 품위 유지를 위해 내장 시, 정장 스타일(재킷)을 착용하여 주시고 일반 운동복, 찢어진 의류, 슬리퍼, 조리, 남성샌들은 삼가하여 주시기 바랍니다.",
    "tab1_body_desc2": "입장 시 출입 제한이 될 수 있습니다.",
    "tab1_body_title2": "라운드 시 삼가야 할 복장",
    "tab1_body_desc3": "상의 : 카라가 없는 상의, 속내의가 훤히 드러나 보이는 상의, 타인에게 혐오감을 줄 수 있는 상의",
    "tab1_body_desc4": "하의 : 청바지, 지나치게 짧은 반바지/스커트, 타인에게 혐오감을 줄 수 있는 하의",
    "tab1_body_desc4_1": "※ 잔디 관리 및 최적의 코스 컨디션 유지를 위해 스파이크화 착용은 제한합니다.",
    "tab1_body_title3": "※ 남성 골퍼 드레스 코드",
    "tab1_body_desc5": "\u00a0\u00a0\u00a0\u00a0반바지 : 무릎 덮는 기장의 반바지 착용",
    "tab1_body_desc6": "\u00a0\u00a0\u00a0\u00a0양말 : 스포츠 양말 또는 발목 덮는 양말 착용(스니커즈 양말 금지)",

    "tab2_body_title1": "예약",
    "tab2_body_desc1_1": "예약은 예약실을 통해서만 예약한다.",
    "tab2_body_desc1_2": "메일 또는 팩스 예약 신청 및 취소는 지정양식에 의거 정확히 기재한다.",
    "tab2_body_desc1_3": "단체 팀은 경기 하루 전까지 조편성표를 통보해야 한다.",
    "tab2_body_desc1_4": "EAST, WEST 코스 초등학생이하는 라운딩 불가.",
    "tab2_body_desc1_5": "\u00a0\u00a0단, NORTH 코스는 초등학생(8세~13세)은 라운딩 가능",

    "tab2_body_title2": "입장",
    "tab2_body_desc2_1": "여유로운 라운딩을 위해 예약시간 40분 전에 도착한다.",
    "tab2_body_desc2_2": "라운딩 전 레스토랑 이용 시에는 1시간 반 이상 여유를 두어 방문한다.",
    "tab2_body_desc2_3": "셀프 주차이니 현관에서 클럽을 내리고 고객 주차장에 안전하게 주차한다.",

    "tab2_body_title3": "등록",
    "tab2_body_desc3_1": "내장 시 복장 규정을 준수하고 골프 에티켓에 맞는 언행을 한다.",

    "tab2_body_title4": "라운드 준비",
    "tab2_body_desc4_1": "라운드 시 삼가야 할 복장",
    "tab2_body_desc4_1_1": "- 카라 없는 상의",
    "tab2_body_desc4_1_2": "- 청바지, 트레이닝복",
    "tab2_body_desc4_1_3": "- 무릎 위로 올라오는 반바지(남성 플레이어), 짧은 스커트(여성 플레이어)",
    "tab2_body_desc4_1_4": "- 속내의가 많이 보이는 상의",
    "tab2_body_desc4_1_5": "- 타인에게 혐오감을 줄 수 있는 상의, 하의",
    "tab2_body_desc4_1_6": "- 문신이 보이는 복장",
    "tab2_body_desc4_2": "Tee-Off 10분전에 동반자와 함께 스타트에 대기한다.",
    "tab2_body_desc4_3": "확정된 팀의 명단을 임의로 변경하지 않는다.",
    "tab2_body_desc4_4": "경기진행 근무자의 안내에 따라 경기를 시작한다.",
    "tab2_body_desc4_5": "팀의 일원이 미도착 시 먼저 진행하고 나중에 합류한다.",

    "tab2_body_title5": "그린",
    "tab2_body_desc5_1": "그린 보수 및 볼 마크는 자신이 직접 한다.",
    "tab2_body_desc5_2": "그린 라이를 밟지 말고 볼라이 후방에 서지 않는다.",
    "tab2_body_desc5_3": "깃대를 뽑아 놓을 때는 그린 엣지에 살짝 놓는다.",
    "tab2_body_desc5_4": "퍼팅이 끝난 후 깃대를 홀 컵에 다시 꽂는다.",
    "tab2_body_desc5_5": "홀 겁 주위 30센티는 밟지 않는다.",
    "tab2_body_desc5_6": "퍼팅이 끝나면 신속히 홀 아웃 한다.",

    "tab2_body_title6": "티잉그라운드",
    "tab2_body_desc6_1": "티샷하는 플레이어 이외에는 티잉그라운드에 올라가지 않는다.",
    "tab2_body_desc6_2": "티샷 전에 2회 이상의 연습스윙은 하지 않는다.",
    "tab2_body_desc6_3": "티샷할 경우 바로 후방에 서지 않고 정숙을 유지한다.",
    "tab2_body_desc6_4": "앞 팀의 세컨샷이 모두 끝난 후 티샷한다.",
    "tab2_body_desc6_5": "앞 팀과의 충분한 안전거리를 유지 후 티샷한다.",

    "tab2_body_title7": "페어웨이",
    "tab2_body_desc7_1": "코스 내에서 지정된 장소 이외에는 금연한다.",
    "tab2_body_desc7_2": "클럽은 플레이어 자신이 선택하고 간수한다.",
    "tab2_body_desc7_3": "타인에게 방해가 되는 야유 행위를 하지 않는다.",
    "tab2_body_desc7_4": "내기 골프 등 사행성 플레이는 하지 않는다.",
    "tab2_body_desc7_5": "음주, 방뇨, 고성방가, 음담패설을 하지 않는다.",
    "tab2_body_desc7_6": "카트는 세컨샷 볼보다 앞에 정차해서는 안 된다.",
    "tab2_body_desc7_7": "OB볼은 5분 이상 찾아서는 안되며 지체 시 뒷 팀을 선행시킨다.",
    "tab2_body_desc7_8": "겨울철은 Tee Play를 하고 해저드 얼음 위의 볼을 주워서는 안된다.",
    "tab2_body_desc7_9": "앞 팀이 그린에 있을 때는 어프로치 샷을 하지 않는다.",

    "tab2_body_title8": "그늘집",
    "tab2_body_desc8_1": "옆 테이블에 방해가 되지 않도록 조용히 한다.",
    "tab2_body_desc8_2": "그늘집에서는 모자를 벗고 레인코트, 우산 등은 지정장소에 놓는다.",
    "tab2_body_desc8_3": "뒷 팀에게 방해가 되지 않도록 지체하지 않고, 앞 팀과의 거리를 지킨다.",

    "tab2_body_title9": "전체입장",
    "tab2_body_desc9_1": "근무자에게 희롱하는 농담이나 팁을 주지 않는다.",
    "tab2_body_desc9_2": "흡연은 지정된 장소에서 하고 정숙을 유지한다.",
    "tab2_body_desc9_3": "코스 내 플레이 시 음식물 지참을 금한다.",

    "tab3_body_title1": "경계는 다음과 같이 표시한다.",
    "tab3_body_desc1_1": "아웃오브바운드(OB)는 하얀 말뚝 또는 선, 워터 해저드는 노란 말뚝 또는 선, 래터럴 워터 해저드는 빨간 말뚝 또는 선, 수리지(언더 리페어)는 청색 말뚝(깃발) 혹은 청색선.",
    "tab3_body_desc1_2": "West 9번홀 그린의 왼쪽에 있는 클럽하우스 그리고 연습장은 흰말뚝과 흰선으로 구분되어 있다.",
    "tab3_body_desc1_3": "주1 : 도로경계석 또는 벽(돌담벽)에는 흰색 점이 찍혀있으며 이 경계를 넘었을 경우에는 OB이다.",
    "tab3_body_desc1_4": "주2 : EAST 2번홀, 8번홀 지하 경계를 넘어간 볼은 OB이다.",

    "tab3_body_title2": "수리지 - 플레이 금지(Rule 25-1)",
    "tab3_body_desc2_1": "West 3홀의 무덤 구역에 흰색선(또는 녹색선)으로 표시된 구역은 자연보호 구역이고 흰색 선으로 표시되어 있는 것은 수리지이며, 플레이 금지구역이다.",
    "tab3_body_desc2_2": "골프규칙 25-1에 의해 벌 없이 구제받을 수 있다.",

    "tab3_body_title3": "구제 받을 수 없는 장해물",
    "tab3_body_desc3_1": "East 4홀 그린 앞 100yd 지점에 있는 원형형태의 돌담, 코스 내에 있는 돌담, 코스 내에 설치된 구조물은 구제 받을 수 없는 고정 장해물이다.",

    "tab3_body_title4": "무벌타 드롭",
    "tab3_body_desc4_1": "퍼팅 그린에 가까이 있는 움직일 수 없는 장해물의 처리(스프링쿨러)의 경우 볼이 퍼팅 그린 밖에 있으나 해저드 안이 아닌 곳에 있는 상황에서, 움직일 수 없는 장해물이 퍼팅 그린 위나 퍼팅 그린에서 2클럽 이내에 있고, 볼에서도 2클럽 길이 이내에 있으며 볼과 홀 사이의 플레이 선상에 걸리는 경우 홀에 더 가깝지 않고 장해물에 걸리는 경우를 피하고 해저드나 그린 위가 아닌 곳으로 무벌타 드롭 할 수 있다.",

    "tab3_body_title5": "경기속도(규칙 6-7의 주2)",
    "tab3_body_desc5_1": "특별한 상황이 없는 한, 첫 조가 허용된 시간 이상으로 지연되는 경우 그 이후의 각 조는 정 위치 이탈 시 계시를 받을 수 있다. 계시가 시작된 이후에는 한 스트로크 당 각 조의 첫 번째 선수에게 50초. 나머지 선수에게 40초의 시간이 주어지며 이를 초과하였을 경우 그 선수는 허용시간을 초과한 것이다. 정 위치 이탈은 홀별 허용시간을 초과하고, 앞조와의 간격이 파3, 파4홀에서 한 홀 이상 벌어지거나, 파 5인 홀에서 앞 조가 그린에서 퍼팅할 때 티잉그라운드에 도착한 경우이다. 계시를 받는 조의 선수가 정 위치로 되돌아갔거나 허용된 시간 안에 경기를 진행한다 하더라도 이미 받은 허용시간 초과에 대한 경고 등은 그 라운드 중 유효하다.",
    "tab3_body_desc5_2": "※ 본 경기 조건 위반에 관한 벌 :",
    "tab3_body_desc5_2_1": "- 허용시간 1회 초과 : 경기 위원으로 부터의 경고",
    "tab3_body_desc5_2_2": "- 허용시간 2회 초과 : 1벌타 부과",
    "tab3_body_desc5_2_3": "- 허용시간 3회 초과 : 2벌타 부과",
    "tab3_body_desc5_2_4": "- 허용시간 4회 초과 : 경기 실격",

    "tab3_body_title6": "라운드중의 연습 : (규칙 7-2의 주2: a.b. 추가 사항)",
    "tab3_body_desc6_1": "플레이어는 한 홀의 플레이 중에 연습 스트로크를 해서는 안 된다. 또 홀과 홀 사이에도 연습 스트로크를 해서는 안 된다.",
    "tab3_body_desc6_2": "주1 : 방금 플레이한 홀의 퍼팅그린 위에서나 그 근처에서의 연습 행위",
    "tab3_body_desc6_3": "주2 : 방금 플레이한 홀의 퍼팅그린 위에서 볼을 굴리는 행위",

    "tab3_body_title7": "전자기기",
    "tab3_body_desc7_1": "전자기기 및 거리측정장치는 사용하여서는 안 된다.",

    "tab3_body_title8": "드롭존 설치지역",
    "tab3_body_desc8_1": "East 8홀 그린 뒤 (3개소) 8홀 그린의 우측과 뒤쪽의 흰 점선으로 표시된 지역의 카트도로에 공이 있을 경우, 선수는 골프 규칙 24-2(움직일 수 없는 장해물) 또는 추가적 선택사항으로 벌없이 세 개의 드롭존 가운데 가장 가까운 드롭존을 사용할 수 있다.",

    "tab3_body_title9": "드롭존 선택",
    "tab3_body_desc9_1": "워터 해저드 East 2홀과 5홀, West 9홀 (Rule 25) 그린 앞에 있는 워터 해저드에 들어간 경우, 골프규칙 25-1에 의해 선택적으로 드롭존을 사용할 수 있다.(해저드 티 설치되어 있음)",

    "tab3_body_title10": "래터럴 워터 해저드(Rule 25)",
    "tab3_body_desc10_1": "표시 되지 않은 콘크리트 배수로도 포함되며 배수로 안쪽 끝부분을 경계로 한다.",
    "tab3_body_desc10_2": "East 4홀, 6홀, West 5홀 좌측 / West 1번홀 그린 뒤 / West 6, 7, 9번홀 우측",

    "tab3_body_title11": "움직일 수 없는 장애물(Rule 24-2)",
    "tab3_body_desc11_1": "East 7홀, 8홀, West 7홀 : East 8번홀 그린 뒤쪽과 그린 오른쪽 카트 도로에 공이 있을 경우, 흰 점선으로 표시된 East 7홀, West 7홀 그린 좌측. 선수는 골프규칙 24-2 또는 추가적 선택사항으로 벌 없이 드롭존 가운데 가장 가까운 드롭존을 사용할 수 있다.",
    "tab3_body_desc11_2": "나무 말뚝 : 구제는 나무말뚝에 의한 샷 방해만 해당된다.",
    "tab3_body_desc11_3": "코스시설물로써 인정되어 흰색 선으로 둘러쳐져 있는 East 5홀 그늘집",

    "tab3_body_title12": "임시고정 장애물",
    "tab3_body_desc12_1": "볼이 광고판 등 임시 고정장애물(TIO)의 안에, 위에, 아래에 또는 뒤에 놓였을 경우 구제는 양쪽으로 선택할 수 있다.",

    "tab3_body_title13": "상기 이외의 모든 룰은 대한골프협회 룰에 의하는 것으로 한다.",

    "tab4_body_title1": "변기수의 골프장 블랙박스"
  }
  ,"en": {
  "breadcrumb": "Operation Guide",
  "info_title": "Operation Guide",
  "tab1_title": "Dress Code",
  "tab2_title": "Golf Manners",
  "tab3_title": "LOCAL RULES",
  "tab4_title": "변기수의 골프장 블랙박스_en",

  "tab1_body_title1": "On Visit",
  "tab1_body_desc1": "Please wear formal dress style (jacket) as much as possible to maintain club's dignity and refrain from shorts, jeans and slippers.",
  "tab1_body_desc2": " ",

  "tab1_body_title2": "Dresses to avoid during rounds",
  "tab1_body_desc3": "Top: The top without collar, the top clearly showing the underwear, the top that may be repellent to others",
  "tab1_body_desc4": "Bottoms: Jeans, shorts / skirts that are too short, bottoms that may be repellent to others",
  "tab1_body_desc4_1": "※ To ensure proper turf management and maintain optimal course conditions, the use of spiked shoes is restricted.",

  "tab1_body_title3": "※ Male golfer dress code",
  "tab1_body_desc5": "\u00a0\u00a0\u00a0\u00a0Shorts: Wear shorts that cover knees",
  "tab1_body_desc6": "\u00a0\u00a0\u00a0\u00a0Socks: Wear sports socks or ankle socks (no sneakers socks)",

  "tab2_body_title1": "Reservation",
  "tab2_body_desc1_1": "Reservations are made only through the reservation room.",
  "tab2_body_desc1_2": "For reservation and cancellation by mail or fax, indicate enter required information correctly by using a designated form.",
  "tab2_body_desc1_3": "The group team must notify the table or team organization until the day before the game.",
  "tab2_body_desc1_4": "East and West courses are not allowed for elementary school students or younger.",
  "tab2_body_desc1_5": "\u00a0\u00a0\u00a0\u00a0However, in the NORTH course, rounds are available for elementary school students (ages 8 to 13).",

  "tab2_body_title2": "Admission",
  "tab2_body_desc2_1": "Arrive 40 minutes before the scheduled time for a leisurely round.",
  "tab2_body_desc2_2": "If you wish to use the restaurant before the game, you will have to come at least one and a half hours earlier.",
  "tab2_body_desc2_3": "For you need to park your car yourself, unload the clubs at the front door and park in the parking lot safely.",

  "tab2_body_title3": "Registration",
  "tab2_body_desc3_1": "Wear a formal style dress (jacket) when visiting the club.",

  "tab2_body_title4": "Prepare for a round",
  "tab2_body_desc4_1": "Dresses to avoid during rounds",
  "tab2_body_desc4_1_1": "- A top which clearly shoes the underwear",
  "tab2_body_desc4_1_2": "- A top that may be repellent to others",
  "tab2_body_desc4_1_3": "- Shorts not coving knees (men)",
  "tab2_body_desc4_1_4": "- Jeans, short skirts",
  "tab2_body_desc4_1_5": "- Bottoms that may be repellent to others",
  "tab2_body_desc4_1_6": "- tattoo-looking outfit",
  "tab2_body_desc4_2": "Wait with companion at the start 10 minutes before tee-off.",
  "tab2_body_desc4_3": "Do not arbitrarily change the fixed list of teams.",
  "tab2_body_desc4_4": "Start the round following the instructions of the operator.",
  "tab2_body_desc4_5": "If a member of the team has not arrived, proceed first and let the member join later.",

  "tab2_body_title5": "Green",
  "tab2_body_desc5_1": "Repair green and mark the ball by yourself.",
  "tab2_body_desc5_2": "Do not step on the green lie or stand behind the ball lie.",
  "tab2_body_desc5_3": "When you pull out the flagpole, put it gently on the green edge.",
  "tab2_body_desc5_4": "After putting, put the flagpole back into the hole cup.",
  "tab2_body_desc5_5": "Do not step within 30 centimeters radius of the hole.",
  "tab2_body_desc5_6": "After putting, quickly hole out.",

  "tab2_body_title6": "Teeing ground",
  "tab2_body_desc6_1": "Do not enter the teeing ground unless it is for tee shot.",
  "tab2_body_desc6_2": "Do not practice swing more than twice before tee shot.",
  "tab2_body_desc6_3": "When you strike a tee shot, do not stand in the back immediately but keep quiet.",
  "tab2_body_desc6_4": "Strike tee shot after the second shots of the foregoing team are finished.",
  "tab2_body_desc6_5": "Keep a safe distance from the foregoing team before striking tee shot.",

  "tab2_body_title7": "Fairway",
  "tab2_body_desc7_1": "Smoking is not allowed outside the designated area within the course.",
  "tab2_body_desc7_2": "Clubs must be chosen and cared by yourself",
  "tab2_body_desc7_3": "Do not interfere with others with jeer, etc.",
  "tab2_body_desc7_4": "Do not engage in gambling play such as wagering on play result.",
  "tab2_body_desc7_5": "Do not drinking, urinate, sing loudly, or make obscene remarks",
  "tab2_body_desc7_6": "The cart should not stop further than the second shot ball.",
  "tab2_body_desc7_7": "OB balls should not be searched for more than 5 minutes. Let the following team play first in case of delay.",
  "tab2_body_desc7_8": "In winter, use tee for playing and do not pick up the ball on hazard ice.",
  "tab2_body_desc7_9": "Do not make an approach shot when the foregoing team is on the green.",

  "tab2_body_title8": "Shade House",
  "tab2_body_desc8_1": "Keep quiet not to disturb people at other tables.",
  "tab2_body_desc8_2": "In the shade house, take off the hat and place the raincoat, umbrella, etc. in the designated place.",
  "tab2_body_desc8_3": "Make no delay not to interfere with the following team and keep the distance from the foregoing team.",

  "tab2_body_title9": "Entry of all",
  "tab2_body_desc9_1": "Do not make a joke that ridicules the staff or tip them.",
  "tab2_body_desc9_2": "Smoke in the designated place only and kept quiet.",
  "tab2_body_desc9_3": "Do not bring any food when playing in the course.",

  "tab3_body_title1": "The boundary is marked as follows.",
  "tab3_body_desc1_1": "Out of Bound (OB) with white piles or lines; Water Hazards with yellow piles or lines; Lateral Water Hazards with red piles or lines; Under Repair with blue piles (flags) or lines;",
  "tab3_body_desc1_2": "The Club House and Approach Zone on the left side of the green of the West hole 9 are distinguished by a white piles and lines.",
  "tab3_body_desc1_3": "Note 1: Road boundaries or walls (stone wall) are marked with white dots and beyond these marks is OB.",
  "tab3_body_desc1_4": "Note 2: The ball that passes over the underground boundary of EAST holes 2 and 8 is OB.",

  "tab3_body_title2": "Under Repair - Prohibited (Rule 25-1)",
  "tab3_body_desc2_1": "The area marked with white lines (or green line) in the graveyard area of the West hole 3 is the Nature Preservation Area, and the area marked with the white lines is the Under Repair area which is prohibited area for play.",
  "tab3_body_desc2_2": "You may be relieved without penalty pursuant to the Golf Rule 25-1.",

  "tab3_body_title3": "Obstructions without relief",
  "tab3_body_desc3_1": "The round stone wall 100 yd before the green of the East hole 4, the stone wall inside the course, and structures installed inside course are fixed obstructions for which you will not be relieved",

  "tab3_body_title4": "Drop without penalty",
  "tab3_body_desc4_1": "In the case of an immovable obstruction close to the putting green (sprinkler), if the ball is outside the putting green but not inside the hazard and the immovable obstruction is on the putting green or within two club’s lengths from the putting green and also from the ball and is in the middle of the play line between the ball and the hole, the player may drop the ball without penalty shot on the place other than hazard or green which is not closer to the hole and interfered by another obstruction.",

  "tab3_body_title5": "Speed of Play (Note 2 of Rule 6-7)",
  "tab3_body_desc5_1": "Unless there are special circumstances, if the first team is delayed beyond the allowed time, each team thereafter may receive time counting when they deviate from the designated position. Once the time counting begins, the first player in each group will be given 50 seconds per stroke and the remaining players, 40 seconds. Exceeding this time is regarded as exceeding the allowed time. Deviating from the designated position means that the player exceeded the time allowed for each hole or when the distance to the foregoing team exceeded one or more hole in par 3 or par 4 hole, or when the team arrived at the teeing ground when the foregoing team was putting in front of par 5 hole. Even when the player who received time counting returns to the designated position or plays within allowed time, the warning, and so on given for the excess of allowed time remains valid during the round.",
  "tab3_body_desc5_2": "※ Penalties for violating these play rules :",
  "tab3_body_desc5_2_1": "- Exceeding the allowed time once: Warning from the referee",
  "tab3_body_desc5_2_2": "- Exceeding the allowed time twice: 1 penalty shot",
  "tab3_body_desc5_2_3": "- Exceeding the allowed time three times: 2 penalty shots",
  "tab3_body_desc5_2_4": "- Exceeding the allowed time four times: Disqualified",

  "tab3_body_title6": "Practicing during round: (Note 2: a.b. Additional Rules of Rule 7-2)",
  "tab3_body_desc6_1": "Players should not practice strokes during around with a hole and also between holes.",
  "tab3_body_desc6_2": "Note 1: Practicing on or near the putting green of the hole just played",
  "tab3_body_desc6_3": "Note 2: Rolling the ball on the putting green of the hole just played",

  "tab3_body_title7": "Electronic devices",
  "tab3_body_desc7_1": "Electronic device and distance measuring instrument must not be used.",

  "tab3_body_title8": "Drop zone installation area",
  "tab3_body_desc8_1": "If the ball is located on the cart road in the area marked with white dots on the right and rear sides of the green of hole 8 behind the green of East hole 8 (three places), the player may use the nearest drop zone among the three drop zones without penalty according to Golf Rule 24-2 (Immovable Obstruction) or additional option.",

  "tab3_body_title9": "Selection of Drop Zone",
  "tab3_body_desc9_1": "Water Hazard: If the ball falls into the water hazard in front of the greens of East hole 2 and 5 and West hole 9 (Rule 25), you can use the drop zone selectively according to Rule 25-1.(Hazard tee is installed)",

  "tab3_body_title10": "Lateral Water Hazard (Rule 25)",
  "tab3_body_desc10_1": "It includes unmarked concrete drainage, bounding on the inner edge of the drainage.",
  "tab3_body_desc10_2": "Left side of East hole 4 and 6, West hole 5 / behind the green of West hole 1 / West hole 6, 7, 9",

  "tab3_body_title11": "Immovable Obstructions (Rule 24-2)",
  "tab3_body_desc11_1": "East hole 7 and 8, West hole 7: If the ball is located on the card road behind and on the right side of the green of East hole 8, left side of the green of East hole 7 and West hole 7 with white dotted line. The player may use the nearest drop zone among the drop zones without penalty according to Golf Rule 24-2 or additional option.",
  "tab3_body_desc11_2": "Wood Pile: The relief is given only when the shot was interfered by the wooden pile.",
  "tab3_body_desc11_3": "- East hole 5 shade house is acknowledged as course facility and surrounded by white line",

  "tab3_body_title12": "Temporarily Immovable Obstructions",
  "tab3_body_desc12_1": "If the ball is placed inside, above, below or behind a temporary immovable obstruction (TIO) such as a billboard, the relief can be selected on both sides.",

  "tab3_body_title13": "Refer to the rules provided by Korea Golf Association for the rules not listed above.",

  "tab4_body_title1": "변기수의 골프장 블랙박스_en"
  }
  ,"ja": {
  "breadcrumb": "ご利用案内",
  "info_title": "ご利用案内",
  "tab1_title": "ドレスコード",
  "tab2_title": "ゴルフのエチケット",
  "tab3_title": "ローカル・ルール",
  "tab4_title": "변기수의 골프장 블랙박스_ja",

  "tab1_body_title1": "ご来場時",
  "tab1_body_desc1": "品位あるクラブライフをお楽しみいただくために、なるべくブレザー・ジャケットをご着用ください。半ズボン、ジーンズ、",
  "tab1_body_desc2": "サンダルなどでのご来場はご遠慮ください。",
  "tab1_body_title2": "プレー時にご遠慮いただく服装",
  "tab1_body_desc3": "上衣：襟のない上衣、下着が目立って見えるような上衣、他の人に不快感を与えるようなもの",
  "tab1_body_desc4": "下衣：ジーンズ、極端に短い半ズボン、スカート、他の人に不快感を与えるような下衣",
  "tab1_body_desc4_1": "※ To ensure proper turf management and maintain optimal course conditions, the use of spiked shoes is restricted.",
  "tab1_body_title3": "※ 男性ゴルファーのドレスコード",
  "tab1_body_desc5": "\u00a0\u00a0\u00a0\u00a0半ズボン：ひざが隠れる長さの半ズボンを着用",
  "tab1_body_desc6": "\u00a0\u00a0\u00a0\u00a0ソックス：スポーツソックスまたは足首が隠れるソックスを着用（アンクルソックスは禁止）",

  "tab2_body_title1": "予約",
  "tab2_body_desc1_1": "予約センターを通じて予約する。",
  "tab2_body_desc1_2": "メールあるいはファックスでの予約申し込みおよびキャンセルは指定の書式に正確に記載する。",
  "tab2_body_desc1_3": "団体チームはプレーの前日までに組み合わせを通知する。",
  "tab2_body_desc1_4": "EAST、WESTコース 小学生がするラウンド不可。",
  "tab2_body_desc1_5": "\u00a0\u00a0\u00a0\u00a0단, NORTH 코스는 초등학생(8세~13세)은 라운딩 가능",

  "tab2_body_title2": "入場",
  "tab2_body_desc2_1": "余裕をもってプレーするためにスタート時間の40分前までに到着する。",
  "tab2_body_desc2_2": "スタート前にレストランを利用する場合には1時間半以上の余裕をもって到着する。",
  "tab2_body_desc2_3": "駐車はクラブハウスの玄関でゴルフバッグを降ろしてから駐車場に停める。",

  "tab2_body_title3": "受付",
  "tab2_body_desc3_1": "入場時には上着（ジャケット）を着用する。",

  "tab2_body_title4": "プレーの準備",
  "tab2_body_desc4_1": "プレーの際に避けるべき服装",
  "tab2_body_desc4_1_1": "- 下着が目立って見えるような上衣",
  "tab2_body_desc4_1_2": "- 他の人に不快感を与えるような上衣",
  "tab2_body_desc4_1_3": "- 膝上の長さの半ズボン（男性プレーヤー）",
  "tab2_body_desc4_1_4": "- ジーンズ、短いスカート",
  "tab2_body_desc4_1_5": "- 他の人に不快感を与えるような下衣",
  "tab2_body_desc4_1_6": "- 문신이 보이는 복장",
  "tab2_body_desc4_2": "スタート時間の10分前に同伴者と共にティーグラウンドで待機する。",
  "tab2_body_desc4_3": "決まっている組の名簿を任意に変更しない。",
  "tab2_body_desc4_4": "プレー進行スタッフの案内に従ってプレーを開始する。",
  "tab2_body_desc4_5": "組の中で到着していない人がいる場合には先にスタートして後から合流する。",

  "tab2_body_title5": "グリーン",
  "tab2_body_desc5_1": "グリーンのディポット跡やピッチマークは自分で直す。",
  "tab2_body_desc5_2": "グリーンのライを踏まないこと。ボールライの後方に立たない。",
  "tab2_body_desc5_3": "ピンを抜いて置く場合には、グリーンのエッジに静かに置く",
  "tab2_body_desc5_4": "パッティングが終わったらピンをホールカップに戻す。",
  "tab2_body_desc5_5": "ホールカップの周囲30センチは踏まない。",
  "tab2_body_desc5_6": "パッティングが終わったら素早くホールアウトする。",

  "tab2_body_title6": "ティーグラウンド",
  "tab2_body_desc6_1": "ティーショットをするプレーヤー以外にはティーグラウンドに立ち入らない。",
  "tab2_body_desc6_2": "ティーショットの前に2度以上の練習スイングはしない。",
  "tab2_body_desc6_3": "ティーショットをするプレーヤーの後ろには立たず静粛を保つ。",
  "tab2_body_desc6_4": "前の組のセカンドショットがすべて終わってからティーショットをする。",
  "tab2_body_desc6_5": "前の組と十分な安遠距離が保たれていることを確認してからティーショットを行う",

  "tab2_body_title7": "フェアウェイ",
  "tab2_body_desc7_1": "コース内で指定された場所以外で喫煙しない。",
  "tab2_body_desc7_2": "クラブはプレーヤーが自分で選んで管理する。",
  "tab2_body_desc7_3": "他のプレーヤーの妨げとなる揶揄行為はしない。",
  "tab2_body_desc7_4": "賭けゴルフなど射幸心を煽るプレーはしない。",
  "tab2_body_desc7_5": "飲酒、放尿、高声、放歌、風紀を乱すようなことはしない。",
  "tab2_body_desc7_6": "カートはセカンドショットのボールより先に停車しない。",
  "tab2_body_desc7_7": "OBとなったボールは5分以上探さない。遅れた場合には後ろの組が先にプレーする。",
  "tab2_body_desc7_8": "冬期はTee Playをし、ハザードの氷の上のボールは拾わない。",
  "tab2_body_desc7_9": "前の組がグリーン上にいる場合にはアプローチショットをしない。",

  "tab2_body_title8": "茶店",
  "tab2_body_desc8_1": "横のテーブルの妨げとならないように静かにする。",
  "tab2_body_desc8_2": "茶店では帽子を脱ぎ、レインコートや傘などは指定された場所に置く。",
  "tab2_body_desc8_3": "前の組との間隔を保って後ろの組の妨げとならないようにする。",

  "tab2_body_title9": "全般",
  "tab2_body_desc9_1": "スタッフをひやかすような冗談を言ったりチップを出したりしない。",
  "tab2_body_desc9_2": "喫煙は指定された場所で静かにする。",
  "tab2_body_desc9_3": "コースでのプレーの際に飲食物は持ち込まない。",

  "tab3_body_title1": "境界は下記のように表示する。",
  "tab3_body_desc1_1": "アウトオブバウンズ（OB）は白杭または線、ウォーターハザードは黄杭または線、ラテラル・ウォーターハザードは赤杭または線、修理地（アンダーリペア）は青杭（フラグ）または青線",
  "tab3_body_desc1_2": "West9番ホールのグリーン左側にあるクラブハウスと練習場は、白杭と白線で区分されている。",
  "tab3_body_desc1_3": "注1：道路の境界石または垣（石垣）には白い点が表示されておりこの境界を越えた場合にはOBとなる。",
  "tab3_body_desc1_4": "注2：East 2番ホール、8番ホールの地下の境界を越えたボールはOBとなる。",

  "tab3_body_title2": "修理地－プレー禁止（Rule-2-1）",
  "tab3_body_desc2_1": "West 3番ホールの墓域に白線（又は緑線）で表示された区域は自然保護区域、白線で表示されているのは修理地で、プレー禁止区域とする。",
  "tab3_body_desc2_2": "\u00a0\u00a0\u00a0\u00a0ゴルフ規則25-1により無罰で救済を受けることができる。",

  "tab3_body_title3": "救済が受けられない障害物",
  "tab3_body_desc3_1": "East 4番ホールのグリーン前100ヤード地点にある円形の石垣、コース内にある石垣、コース内に設置された構造物は救済が受けられない固定障害物とする。",

  "tab3_body_title4": "無罰ドロップ",
  "tab3_body_desc4_1": "パッティンググリーンの近くにある動かすことのできない障害物の処理（スプリンクラー）の場合には、ボールがパッティンググリーンの外にあるがハザードの中ではない所にある状況において、動かすことのできない障害物がパッティンググリーンの上やパッティンググリーンから2クラブレングス以内にあれば、ボールとホールの間のプレーライン上にかかる場合には、ホールにより近い所ではなく、障害物に引っかかるのを避けてハザードやグリーンの上ではない場所に無罰ドロップすることができる。",

  "tab3_body_title5": "競技速度（規則6—7の注2）",
  "tab3_body_desc5_1": "特別な状況でない限り、最初の組が許容時間をオーバーした場合、その後にアウトオブポジションになると時間の計測がなされることがある。時間の計測が始まった後は、1ストロークあたり各組の最初のプレーヤーに50秒、残りのプレーヤーには40秒の時間が与えられ、これを超えた場合にはそのプレーヤーは許容時間を超過したことになる。アウトオブポジションは、ホールごとの許容時間を超過し、前の組との間隔がパー3、パー4で1ホール以上、パー5のホールで前の組がグリーンでパッティングするときにティーグラウンドに到着した場合とする。時間の計測がなされる組のプレーヤーがポジションを回復した場合や、許容時間をオーバーしなかったとしても、すでに受けた許容時間オーバーに対する警告などはそのラウンド中、有効となる。",
  "tab3_body_desc5_2": "※ プレー条件違反に関するペナルティ :",
  "tab3_body_desc5_2_1": "- 許容時間1回オーバー：競技委員からの警告",
  "tab3_body_desc5_2_2": "- 許容時間2回オーバー：1罰打付加",
  "tab3_body_desc5_2_3": "- 許容時間3回オーバー：2罰打付加",
  "tab3_body_desc5_2_4": "- 許容時間4回オーバー：競技失格",

  "tab3_body_title6": "ラウンド中の練習：（規則7—2の注2：a.b追加事項)",
  "tab3_body_desc6_1": "プレーヤーはあるホールのプレー中に練習ストロークをしてはならない。また、ホールとホールの間でも練習ストロークをしてはならない。",
  "tab3_body_desc6_2": "注1：プレーが終わったホールのパッティンググリーンの上やその近くでの練習行為",
  "tab3_body_desc6_3": "注2：プレーが終わったホールのパッティンググリーンの上でボールを転がす行為",

  "tab3_body_title7": "電子機器",
  "tab3_body_desc7_1": "電子機器および距離測定器は使用してはならない。",

  "tab3_body_title8": "ドロップゾーン設置区域",
  "tab3_body_desc8_1": "East8ホールのグリーン後方（3か所）8ホールのグリーン右側の後方の白い点線で表示された地域のカート道路にボールがある場合、プレーヤーはゴルフ規則24—2（動かせる障害物）または追加的選択事項としてペナルティなしに3つのドロップゾーンの中でもっとも近いドロップゾーンを使用することができる。",

  "tab3_body_title9": "ドロップゾーンの選択",
  "tab3_body_desc9_1": "ウォーターハザードEast2ホールと5ホール、West9ホール（Rule25）のグリーン前にあるウォーターハザードに入った場合には、ゴルフ規則25—1により選択的にドロップゾーンを使用することができる。",

  "tab3_body_title10": "ラテラル・ウォーターハザード（Rule25）",
  "tab3_body_desc10_1": "表示のないコンクリート排水路も含まれ、排水路内側の端を境界とする。",
  "tab3_body_desc10_2": "East4ホール、West5ホール左側/West1番ホールのグリーン後方/West6、7、9番ホール右側",

  "tab3_body_title11": "動かすことのできない障害物（Rule24-2）",
  "tab3_body_desc11_1": "East 7ホール、8ホール、West 7ホール：East 8ホールのグリーン後方とグリーン右側のカート道路にボールがある場合には、白い点線で表示されたEast 7ホール、West 7ホールのグリーン左側。プレーヤーはゴルフ規則24—2または追加的選択事項によりペナルティなしにドロップゾーンの中でもっとも近いドロップゾーンを使用することができる。",
  "tab3_body_desc11_2": "木杭：救済は木杭によるショットの妨害のみ該当する。",
  "tab3_body_desc11_3": "コースの施設物として認められ白線で囲まれているEast 5の茶店",

  "tab3_body_title12": "臨時の動かせない障害物",
  "tab3_body_desc12_1": "ボールが広告板などの臨時の動かせない障害物（TIO）の中、上、下または後ろに止まった場合の救済は両側から選択することができる。",

  "tab3_body_title13": "上記以外のすべてのルールは大韓ゴルフ協会のルールによるものとする。",

  "tab4_body_title1": "변기수의 골프장 블랙박스_ja"
  }
}
</i18n>
